import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router'
import styled from 'styled-components'

import { profileAlignmentStyleCss } from 'components/page/ProfileSharing/ProfileSharing.styled'
import { ProfileRouteParams } from 'components/paths'
import { media } from 'components/presentational'
import { OrdinaryButton } from 'components/presentational/button'
import { useTooltip } from 'hooks/useTooltip'

import { SharingType } from '../SharingContent/SharingContent.constant'
import { SharingContent } from '../SharingContent/SharingContentIndex'

export const SharingButtonWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  width: 300px;

  ${media.phone`
    width: 100%;
  `}
`

export const ProfileSocialSharing: FC = () => {
  const { userId } = useParams<ProfileRouteParams>()
  const [tooltipState, toggleTooltipState] = useTooltip(
    `${SharingType.profile}-${userId}`
  )

  if (userId) {
    const userIdNumber = Number(userId)
    return (
      <SharingButtonWrapper>
        {tooltipState && (
          <SharingContent
            type={SharingType.profile}
            contentId={userIdNumber}
            profileId={userIdNumber}
            alignmentStyleCss={profileAlignmentStyleCss}
          />
        )}
        <div style={{ flexGrow: 1 }}>
          <OrdinaryButton
            onClick={toggleTooltipState}
            data-name={`sharing-profile-${userId}-action`}
          >
            <FormattedMessage
              id="profile.share.button"
              defaultMessage="Поделиться анкетой"
            />
          </OrdinaryButton>
        </div>
      </SharingButtonWrapper>
    )
  }

  return null
}
